import { useAuthStore } from '../store/authStore'
import { apiClient } from '../services/api'
import { appInsights } from '../insights'
import { useToast } from '../components/shared/Toast'
import type { AuthResponse, OtpRequest, OtpVerify } from '@shared/types/api'

export function useAuth() {
  const { user, setAuth, clearAuth } = useAuthStore()
  const { showToast } = useToast()

  async function requestOtp(payload: OtpRequest) {
    const res = await apiClient.post<{ expiresIn: number; warning?: string }>('/api/auth/request-otp', payload)
    if (res.warning) showToast(res.warning, 'warning')
    return res
  }

  async function verifyOtp(payload: OtpVerify) {
    const result = await apiClient.post<AuthResponse>('/api/auth/verify-otp', payload)
    setAuth(result)
    appInsights.setAuthenticatedUserContext(result.userId)
    return result
  }

  async function logout() {
    await apiClient.post('/api/auth/logout').catch(() => {})
    clearAuth()
    appInsights.clearAuthenticatedUserContext()
  }

  return { user, requestOtp, verifyOtp, logout }
}
